module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "size": "mini",
      "clearable": "",
      "type": "daterange",
      "picker-options": _vm.pickerOptions,
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "right"
    },
    model: {
      value: (_vm.params.times),
      callback: function($$v) {
        _vm.$set(_vm.params, "times", $$v)
      },
      expression: "params.times"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.syncCoupon()
      }
    }
  }, [_vm._v("同步券包")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.dataList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "package_num_id",
      "label": "券包编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "package_name",
      "label": "券包名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_fee",
      "label": "原总价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.total_fee / 100) + "元\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "retail_fee",
      "label": "现售价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.retail_fee / 100) + "元\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stock_qty",
      "label": "券包库存"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coupon_count",
      "label": "券包里的张数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sale_package_count",
      "label": "已售券包数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("正常")]) : _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("禁用")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.created_at_text) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.show(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pagesize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详细",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [
    [_c('el-table', {
      attrs: {
        "data": _vm.row
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "title",
        "label": "券名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "series",
        "label": "券规则ID"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "coupontype",
        "label": "券类型"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.coupontype == 0) ? _c('el-tag', [_vm._v("\n                    折扣券\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.coupontype == 1) ? _c('el-tag', [_vm._v("\n                  代金券\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.coupontype == 2) ? _c('el-tag', [_vm._v("\n                  免邮券\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.coupontype == 8) ? _c('el-tag', [_vm._v("\n                  兑换券\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.coupontype == 9) ? _c('el-tag', [_vm._v("\n                  服务券\n                ")]) : _vm._e()]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "face_value",
        "label": "券面值"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "stock_qty",
        "label": "券库存"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "status",
        "label": "券状态"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.status == 2) ? _c('el-tag', [_vm._v("\n                   已审核\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-tag', [_vm._v("\n                   终止\n                ")]) : _vm._e()]
        }
      }])
    })], 1)], _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      on: {
        "click": function($event) {
          _vm.dialogVisible = false
        }
      }
    }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.dialogVisible = false
        }
      }
    }, [_vm._v("确 定")])], 1)
  ], 2)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f771658", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f771658"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/cardticket/package/list.vue
// module id = 2525
// module chunks = 0